import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Users, Briefcase, ArrowRight } from 'lucide-react';

const roles = [
  {
    key: 'jobseeker',
    label: 'Job Seeker',
    icon: Users,
    description: 'Looking for opportunities, take tests, and showcase your skills',
    plan: 'Free Plan - ₹0/month',
    route: '/signup/jobseeker',
  },
  {
    key: 'hr',
    label: 'HR / Recruiter',
    icon: Briefcase,
    description: 'Post jobs, create tests, and find the right candidates',
    plan: 'Core Plan - Paid',
    route: '/signup/hr',
  },
];

const SignupChooser: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 relative overflow-hidden">
      {/* Animated Background */}
      <div className="fixed inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50"></div>
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-gradient-to-br from-blue-400/20 to-purple-600/20 rounded-full blur-3xl animate-pulse-slow"></div>
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-gradient-to-tr from-purple-400/20 to-pink-600/20 rounded-full blur-3xl animate-pulse-slow" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="max-w-2xl w-full">
        {/* Header */}
        <div className="text-center mb-10">
          <Link to="/" className="inline-flex items-center space-x-3 mb-6">
            <img src="/vetriaAI.png" alt="VetriaAI Logo" className="w-10 h-10" width="40" height="40" />
            <span className="text-2xl font-bold text-gray-900">VetriaAI</span>
          </Link>
          <h1 className="text-4xl font-bold text-gray-900 mb-2">Create your account</h1>
          <p className="text-lg text-gray-600">Choose how you want to use VetriaAI</p>
        </div>

        {/* Role Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
          {roles.map((role) => {
            const Icon = role.icon;
            return (
              <button
                key={role.key}
                onClick={() => navigate(role.route)}
                className="glass-card backdrop-blur-glass-strong text-left group hover:scale-[1.03] transition-all duration-300 cursor-pointer"
              >
                <div className="flex flex-col items-center text-center p-4">
                  <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <h2 className="text-xl font-bold text-gray-900 mb-2">{role.label}</h2>
                  <p className="text-sm text-gray-600 mb-4">{role.description}</p>
                  <span className="text-sm font-semibold text-gradient">{role.plan}</span>
                  <div className="mt-4 flex items-center text-purple-600 font-semibold text-sm group-hover:gap-2 transition-all duration-300">
                    Get Started <ArrowRight className="ml-1 w-4 h-4" />
                  </div>
                </div>
              </button>
            );
          })}
        </div>

        {/* Login Link */}
        <p className="text-center text-sm text-gray-600">
          Already have an account?{' '}
          <Link to="/login" className="font-semibold text-purple-600 hover:text-purple-800 transition-colors">
            Sign in here
          </Link>
        </p>
      </div>
    </div>
  );
};

export default SignupChooser;
